import axios from "axios";
import { Booking, User } from "../../types/types";
const API_URL = process.env.REACT_APP_API_BASE_URL;

const getAllUsersFromDB: () => Promise<User[]> = async () => {
  try {
    const response = await axios.get(`${API_URL}/dashboard/users`);
    return response.data;
  } catch (error) {
    console.log("Error fetching users: " + error);
  }
};
const getAllpnrsFromDB: () => Promise<Booking[]> = async () => {
  try {
    const response = await axios.get(`${API_URL}/dashboard/pnrs`);
    return response.data;
  } catch (error) {
    console.log("Error fetching users: " + error);
  }
};

const getAllUsersCountFromDB: () => Promise<number> = async () => {
  try {
    const response = await axios.get(`${API_URL}/dashboard/users/count`);
    return response.data;
  } catch (error) {
    console.log("Error fetching users: " + error);
  }
};

const getAllPnrssCountFromDB: () => Promise<number> = async () => {
  try {
    const response = await axios.get(`${API_URL}/dashboard/pnrs/count`);
    return response.data;
  } catch (error) {
    console.log("Error fetching users: " + error);
  }
};
const deletePnrFromDB: (id: number) => Promise<void> = async (id) => {
  try {
    await axios.delete(`${API_URL}/dashboard/pnrs/${id}`);
  } catch (error) {
    throw error;
  }
};

// const handleStatusUpdate: (
//   controlNumber: string,
//   status: string
// ) => Promise<boolean> = async (controlNumber, status) => {
//   try {
//     const response = await axios.patch(
//       `${API_URL}/dashboard/pnrs/updateStatus/${controlNumber}`,
//       { status }
//     );
//     return response.data;
//   } catch (error) {
//     throw error;
//   }
// };

const handleStatusUpdate: (
  controlNumber: string,
  status: string
) => Promise<boolean> = async (controlNumber, status) => {
  try {
    const response = await axios.patch(
      `${API_URL}/dashboard/pnrs/updateStatus/${controlNumber}`,
      {
        status,
        // ✅ FIX: Also update payment status if booking is completed
        ...(status === "Completed" && {
          paymentStatus: 1,
          paidAt: new Date().toISOString(),
        }),
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

const updatePaymentStatus: (
  controlNumber: string,
  paymentStatus: number
) => Promise<boolean> = async (controlNumber, paymentStatus) => {
  try {
    const response = await axios.patch(
      `${API_URL}/dashboard/pnrs/updatePaymentStatus/${controlNumber}`,
      { paymentStatus }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating payment status:", error);
    throw error;
  }
};

const deleteUserFromDB: (id: number) => Promise<void> = async (id) => {
  try {
    await axios.delete(`${API_URL}/dashboard/users/${id}`);
  } catch (error) {
    throw error;
  }
};

export {
  getAllUsersFromDB,
  getAllUsersCountFromDB,
  getAllPnrssCountFromDB,
  getAllpnrsFromDB,
  deletePnrFromDB,
  deleteUserFromDB,
  handleStatusUpdate,
  updatePaymentStatus,
};
